import { Link } from '@remix-run/react';

export default function Index() {
  return (
    <div className="container">
      <h1 className="text-headline-semi">Index</h1>
      <p>Bienvenido a xouba-dashboard</p>
      <div className="px-4 pt-2">
        <h2 className="text-xl">Apps</h2>
        <ul className="list-disc px-4">
          <li className="underline">
            <Link to="/tunnels">Túneles</Link>
          </li>
          <li className="underline">
            <Link to="/construction-sites">Obras</Link>
          </li>
        </ul>
      </div>
      <div className="px-4 pt-2">
        <h2 className="text-xl">Widgets</h2>
        <ul className="list-disc px-4">
          <li className="underline">
            <Link to="/widgets/synchronized-line-chart">
              Gráfico de línea (sincronizado)
            </Link>
          </li>
          <li className="underline">
            <Link to="/widgets/heatmap">Heatmap</Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
